import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'middleEllipsis' })
export class MiddleEllipsisPipe implements PipeTransform {
  // Poniżej 26 ogon gubi numer projektu i „… 01 - Katowice" zrównuje się z „… 02 - Katowice".
  transform(text: string, maxLength: number = 28): string {
    if (!text) {
      return '';
    }

    if (text.length <= maxLength) {
      return text;
    }

    const head = Math.ceil((maxLength - 1) / 2);
    const tail = maxLength - 1 - head;

    return text.slice(0, head) + '…' + text.slice(text.length - tail);
  }
}
